// import * as Vue from 'vue'
import Vue from "vue";
import Vuex from "vuex";

import { BanDo } from "./bando/bando";
// import {jiro} from './modules/jiro'
// import {counter} from './modules/counter'

// Vue.extend(Vuex);
// Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        bando: BanDo,
    },
});
